import type { GetStaticPropsContext } from 'next'
import ArticleRoute, { getArticleStaticProps } from '@/features/article/route'
import { makeStaticProps } from '@/lib/next/makeStaticProps'

export default ArticleRoute

export async function getStaticProps(ctx: GetStaticPropsContext) {
  const { locale } = ctx
  let articleUri = ctx?.params?.slug
  if (typeof articleUri === 'object') {
    articleUri = articleUri[0] ?? ''
  }

  const props = await getArticleStaticProps(articleUri, locale)
  return makeStaticProps(props)
}

export function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  }
}
